import { useMemo } from "react";
import { useHotelPayLaterFees } from "@apac/components/hotels";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { Fees } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import styles from "./PayLaterBreakdownSection.module.scss";

export const PayLaterBreakdownSection = ({
  feeBreakdown,
  className,
  showTotal,
  showTotalOnly,
}: {
  feeBreakdown: Fees;
  className?: string;
  showTotal?: boolean;
  showTotalOnly?: boolean;
}) => {
  const [block, cn] = useModuleBEM(styles, "PayLaterBreakdownSection");
  const { t } = useI18nContext();
  const feeItems = useHotelPayLaterFees({
    feeBreakdown,
    showTotal: showTotal || showTotalOnly,
  });

  const feeItemsOnDisplay = useMemo(() => {
    if (showTotalOnly)
      return feeItems.filter(
        (item) => item.label === t("apac.priceBreakdown.dueAtCheckInLabel")
      );
    return feeItems;
  }, [showTotalOnly, feeBreakdown]);

  return (
    <div
      className={clsx(block, className, {
        [cn("border-top")]: feeItemsOnDisplay.length > 0,
      })}
    >
      {feeItemsOnDisplay.map(({ label, value }) => (
        <div className={cn("item")}>
          <div className={cn("item-label")}>{label}</div>
          <div className={cn("item-value")}>{value}</div>
        </div>
      ))}
    </div>
  );
};
